import { useQuery } from '@apollo/client';

import type { NeffiStatus } from '@xing-com/crate-jobs-domain-apply-types';
import { GetUserNeffiScoreDocument } from '@xing-com/crate-jobs-graphql';

import { getNeffiScoreStatus } from './get-neffi-score-status';

type UseGetUserNeffiScoreReturnValue = {
  normalizedNeffiScore: number;
  neffiStatus: NeffiStatus;
  isNeffiScoreLoading: boolean;
};

export const useGetUserNeffiScore = (
  isLoggedIn: boolean
): UseGetUserNeffiScoreReturnValue => {
  const { data, loading, error } = useQuery(GetUserNeffiScoreDocument, {
    variables: { consumer: 'loggedin.web.jobs.job_application.center' },
    skip: !isLoggedIn,
  });

  const score = data?.viewer?.networkEfficiencyIndicator?.score;
  const normalizedScore = Math.round((score ?? 0) * 100);
  let neffiStatus: NeffiStatus;
  if (loading) {
    neffiStatus = 'pending';
  } else if (score === undefined || error) {
    neffiStatus = 'failed';
  } else {
    neffiStatus = getNeffiScoreStatus(normalizedScore);
  }

  return {
    normalizedNeffiScore: normalizedScore,
    neffiStatus,
    isNeffiScoreLoading: loading,
  };
};
